export const FIELDMESSAGE = 'required';
export const SUCCESSMESSAGE = 'System successfully saved the information';
export const ERRORMESSAGE = 'should not be empty in ';
export const CONTACT_DETAILS_REQ =
  'Please add at least one Contact Information for the Client.';
export const ERROR_MESSAGE =
  'There was an error processing the request. Please retry the transaction.';
export const CLIENT_UNIQUE_ERR =
  'Client ID already exists. Client ID must be unique.';
